// extracted by mini-css-extract-plugin
export default {"worker":"Layouts_worker__Ez+O1","content":"Layouts_content__SIQJx","mobileTopBar":"Layouts_mobileTopBar__YEOrL","mobileChatContent":"Layouts_mobileChatContent__FkgGS"};